module.exports = __webpack_public_path__ + "img/scene-globe.d2808e84.png";